import styled from '@emotion/styled';

export const Container = styled.footer`
  text-align: center;
  color: #E7E7EB;
  margin: 30px auto 0 auto;

  & > p {
    padding: 0;
    margin: 0;
    line-height: 25px;
  }
`;
